import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.webhooks')
  .factory('WebhooksAPI', WebhooksAPI);

function WebhooksAPI(): BringozApi {
  return {
    base: `/webhooks`,
    infiniteScroll: {
      address: `/webhooks`,
      cmd: 'GET'
    },
    actions: {
      getAll: {
        address: '',
        cmd: 'GET',
        updateable: false
      },
      getOne: {
        address: '{id}',
        cmd: 'GET',
        updateable: true
      },
      create: {
        address: '',
        cmd: 'PUT',
        updateable: true
      },
      update: {
        address: '{id}',
        cmd: 'POST',
        updateable: true
      },
      cancel: {
        address: '{id}',
        cmd: 'DELETE',
        updateable: true
      },
      getTopics: {
        address: 'topics',
        cmd: 'GET',
        updateable: true
      }
    }
  }
}
